import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { DTOUserMessage } from '@shared/dto/user_message/dto_user_message';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';

export const remote_user_message_create = async (message_dto: DTOUserMessage) => {
  await send_to_server(ENUM__network_event_client_to_server.USER_SUPPORT_MESSAGE_CREATE, message_dto);
};
